import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  viewChild
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { MobileNumbersService } from '../../../core/services/mobile-numbers.service';

@Component({
    selector: 'app-chip-list',
    templateUrl: './chip-list.component.html',
    standalone: false
})
export class ChipListComponent implements OnInit {
  //#region properties
  separatorKeysCodes: number[] = [ENTER, COMMA];
  itemCtrl = new FormControl();
  filteredItems: Observable<string[]>;

  items: string[] = [];
  allItems: string[] = [];

  @Input('form') input_form: FormGroup;
  @Input('controlName') input_formControlName: string;
  @Input('title') input_title: string;
  @Input('placeholder') input_placeholder: string;
  @Input('maxLength') input_maxLength: number;
  @Input('checkMobileNumbers') input_checkMobileNumbers: boolean = true;
  @Input('checkInputWhenBlur') input_checkInputWhenBlur: boolean = false;
  @Input('separateByComma') input_separateByComma: boolean = true;
  @Input('outputAsArray') input_outputAsArray: boolean = false;

  @Output('items') output_items: any = new EventEmitter<string[]>();
  readonly chipInput = viewChild<ElementRef<HTMLInputElement>>('chipInput');

  //#endregion

  constructor(
    public dialogService: DialogService,
    private mobileNumbersService: MobileNumbersService,
    private translate: TranslateService,

    protected UtilityService: UtilityService
  ) {}

  ngOnInit() {
    if (!this.input_separateByComma) this.separatorKeysCodes = [ENTER];
  }

  add(event: MatChipInputEvent): void {
    let value = (event.value || '').trim();

    value = this.UtilityService.getTextWithEnglishNumber(value);
    // Add item & check mobile numbers
    if (this.input_checkMobileNumbers && value) {
      let mobile =
        this.mobileNumbersService.getCorrectMobileNumbersFromText(value);
      if (mobile) {
        this.items.push(mobile[0]);
      }
    } else if (value) {
      this.items.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.itemCtrl.setValue(null);

    this.emit();
  }

  remove(fruit: string): void {
    const index = this.items.indexOf(fruit);

    if (index >= 0) {
      this.items.splice(index, 1);
    }

    this.emit();
  }

  emit() {
    if (this.input_maxLength)
      if (this.items && this.items.length > this.input_maxLength) {
        this.setMaxLengthError();
        this.items.splice(-1);
      }

    if (this.input_outputAsArray) this.output_items.emit(this.items);
    else this.output_items.emit(this.items.toString());
  }

  checkInputWhenBlur() {
    if (!this.input_checkInputWhenBlur) return;
    var ev = new KeyboardEvent('keydown', {
      altKey: false,
      bubbles: true,
      cancelable: true,
      charCode: 0,
      code: 'Enter',
      composed: true,
      ctrlKey: false,
      detail: 0,
      isComposing: false,
      key: 'Enter',
      keyCode: 13,
      location: 0,
      metaKey: false,
      repeat: false,
      shiftKey: false,
      which: 13,
    });

    this.chipInput().nativeElement.dispatchEvent(ev);
  }

  checkPastedText(event: ClipboardEvent) {
    event.preventDefault();
    let textArray = event.clipboardData.getData('text').split('\r\n');

    if (textArray.length)
      textArray.forEach((value) => {
        value = this.UtilityService.getTextWithEnglishNumber(value);
        // Add item & check mobile numbers
        if (this.input_checkMobileNumbers && value) {
          let mobile =
            this.mobileNumbersService.getCorrectMobileNumbersFromText(value);
          if (mobile) {
            this.items.push(mobile[0]);
          }
        } else if (value) {
          this.items.push(value);
        }
      });

    this.itemCtrl.setValue(null);
    this.emit();
  }

  setMaxLengthError() {
    this.dialogService.openDialog({
      title: 'common.error',
      message: this.translate.instant('messages.maxReceiversMsg', {
        number: this.input_maxLength,
      }),
      status: DialogStatus.error,
    });
    return;
  }
}
